export default class Measure {
    public measure = '';
}